import { formatCurrency } from '@susu/currency';

/**
 * Every price CM renders goes through here, so the display follows `CURRENCY_DISPLAY` in `@susu/currency`
 * (`€99`, `99 PLN`, `$99 CAD`) and not the symbol CDM holds. Whole numbers stay whole, no thousands separator.
 */
export const formatPrice = (amount: number, currencyCode: string): string =>
  formatCurrency(amount, currencyCode, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: false,
  });
